import bsc from './bsc.svg'
import metamask from './metamask.svg'
import walletconnect from './walletconnect.svg'

export const icons = {
  bsc,
  walletconnect,
  metamask
}
